import React, { useRef, useState } from "react";
import { Galleria } from "primereact/galleria";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { Dialog } from "primereact/dialog";

const responsiveOptions = [
    {
        breakpoint: "991px",
        numVisible: 4
    },
    {
        breakpoint: "767px",
        numVisible: 3
    },
    {
        breakpoint: "575px",
        numVisible: 1
    }
];

const Gallery = ({ media }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [galleryVisible, setGalleryVisible] = useState(false);
    const ref = useRef();

    const itemTemplate = (item) => {
        const extension = item.split(".").pop();
        if (["mp4", "webm", "ogv"].includes(extension))  {
            return (
                <video width="640" height="480" controls>
                    <source src={`https://static.dropcontrol.com/${item}`} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            );
        } else if (["png", "jpg", "jpeg", "webp"].includes(extension))  {
            return <img src={`https://static.dropcontrol.com/${item}`} alt={item.alt} style={{ width: "100%", display: "block" }} />;
        } else return null;
    };

    const thumbnailTemplate = (item) => {
        const extension = item.split(".").pop();
        if (["mp4", "webm", "ogv"].includes(extension))  {
            return (
                <div className="mkt-video-thumbnail" >
                    <FontAwesomeIcon style={{ alignSelf: "center", position:"absolute", marginLeft:"61px" }} icon={faPlay} />
                    <video preload="metadata" >
                        <source src={`https://static.dropcontrol.com/${item}#t=3.5`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            );
        } else if (["png", "jpg", "jpeg","webp"].includes(extension))  {
            return <img src={`https://static.dropcontrol.com/${item}`} alt={item.alt} style={{ width: "150px", height: "100%", display: "block" }} />;
        } else return null;
    };
    return (
        <>

            <Dialog
                visible={galleryVisible}
                onHide={() => setGalleryVisible(false)}
                draggable={false}
            >
                <Galleria
                    tabIndex={1}
                    ref={ref}
                    value={media}
                    responsiveOptions={responsiveOptions}
                    numVisible={4}
                    style={{ width: "720px" }}
                    showItemNavigators
                    item={itemTemplate}
                    thumbnail={thumbnailTemplate}
                    className='mkt-gallery'
                    activeIndex={activeIndex}
                    onItemChange={(e) => setActiveIndex(e.index)}
                />
            </Dialog>
            <div className="thumbnails-flex">
                {
                    media && media.map((image, index) => {
                        const extension = image.split(".").pop();
                        if (["png", "jpg", "jpeg","webp"].includes(extension)){
                            // eslint-disable-next-line jsx-a11y/alt-text
                            const imgEl = <img src={`https://static.dropcontrol.com/${image}`} onClick={
                                () => {setActiveIndex(index); setGalleryVisible(true);}
                            }
                            />;
                            return (
                                <div className='mkt-image-thumbnail' key={index}>
                                    {imgEl}
                                </div>
                            );
                        } else if (["mp4", "mpeg"].includes(extension)) {
                            return (
                                <div className="mkt-video-thumbnail" key={index} onClick={
                                    () => {setActiveIndex(index); setGalleryVisible(true);}
                                }
                                >
                                    <FontAwesomeIcon style={{ alignSelf: "center", position:"absolute", marginLeft:"61px" }} icon={faPlay} />
                                    <video className="mkt-video-thumbnail"  preload="metadata" >
                                        <source src={`https://static.dropcontrol.com/${image}#t=3.5`} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            );
                        } else return null;
                    })
                }
            </div>
        </>
    );
};

export default Gallery;
